/* KISMET v2 — cielo de estrellas, contadores de drop, índice con foto flotante, lookbook */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  $$('[data-starfield]').forEach((canvas) => {
    const ctx = canvas.getContext('2d');
    const density = parseFloat(canvas.dataset.density || '1');
    const accent = getComputedStyle(document.documentElement).getPropertyValue('--c-accent').trim() || '#3D4BFF';
    let w, h, dpr, stars = [], shooters = [], raf, visible = true;
    const resize = () => {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const n = Math.round((w * h) / 5200 * density);
      stars = Array.from({ length: n }, () => ({
        x: Math.random() * w, y: Math.random() * h,
        r: Math.random() * 1.3 + .2,
        a: Math.random(), s: Math.random() * .015 + .003,
        z: Math.random() * .35 + .05
      }));
    };
    let mx = 0, my = 0;
    window.addEventListener('pointermove', (e) => { mx = (e.clientX / window.innerWidth - .5); my = (e.clientY / window.innerHeight - .5); }, { passive: true });
    const shoot = () => {
      const fromLeft = Math.random() > .5;
      shooters.push({ x: fromLeft ? Math.random() * w * .5 : w * .5 + Math.random() * w * .5, y: Math.random() * h * .4, vx: (fromLeft ? 1 : -1) * (6 + Math.random() * 5), vy: 2.5 + Math.random() * 2.5, life: 0, max: 50 + Math.random() * 30, accent: Math.random() > .6 });
    };
    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      for (const s of stars) {
        s.a += s.s; const tw = .45 + Math.abs(Math.sin(s.a)) * .55;
        ctx.globalAlpha = tw;
        ctx.fillStyle = '#F2EEE6';
        ctx.beginPath(); ctx.arc(s.x + mx * 30 * s.z, s.y + my * 30 * s.z, s.r, 0, Math.PI * 2); ctx.fill();
      }
      ctx.globalAlpha = 1;
      shooters = shooters.filter((p) => p.life < p.max);
      for (const p of shooters) {
        p.life++; p.x += p.vx; p.y += p.vy;
        const t = 1 - p.life / p.max;
        const g = ctx.createLinearGradient(p.x, p.y, p.x - p.vx * 14, p.y - p.vy * 14);
        g.addColorStop(0, p.accent ? accent : 'rgba(255,255,255,1)');
        g.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.globalAlpha = t; ctx.strokeStyle = g; ctx.lineWidth = 1.6;
        ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(p.x - p.vx * 14, p.y - p.vy * 14); ctx.stroke();
        ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(p.x, p.y, 1.6, 0, Math.PI * 2); ctx.fill();
      }
      ctx.globalAlpha = 1;
      if (Math.random() < .012) shoot();
      if (visible) raf = requestAnimationFrame(draw);
    };
    resize();
    window.addEventListener('resize', () => { resize(); if (reduce) draw(); });
    if (reduce) { visible = false; draw(); return; }
    new IntersectionObserver(([en]) => {
      visible = en.isIntersecting;
      cancelAnimationFrame(raf);
      if (visible) raf = requestAnimationFrame(draw);
    }).observe(canvas);
    setTimeout(shoot, 600);
  });

  const pad = (n) => String(n).padStart(2, '0');
  $$('[data-drop-countdown]').forEach((el) => {
    const mode = el.dataset.mode;
    const end = (() => {
      if (mode === 'date' && el.dataset.end) { const d = new Date(el.dataset.end); if (!isNaN(d)) return d; }
      const d = new Date(); d.setHours(23, 59, 59, 999); return d;
    })();
    const set = (k, v) => { const n = $(`[data-cd="${k}"]`, el); if (n) n.textContent = pad(v); };
    const tick = () => {
      const diff = end - new Date();
      if (diff <= 0) {
        set('d', 0); set('h', 0); set('m', 0); set('s', 0);
        const done = $('[data-cd-done]', el.closest('section') || el); if (done) done.hidden = false;
        if (el.dataset.hideOnEnd === 'true') el.hidden = true;
        return false;
      }
      set('d', Math.floor(diff / 864e5)); set('h', Math.floor(diff % 864e5 / 36e5));
      set('m', Math.floor(diff % 36e5 / 6e4)); set('s', Math.floor(diff % 6e4 / 1e3));
      return true;
    };
    if (tick()) { const iv = setInterval(() => { if (!tick()) clearInterval(iv); }, 1000); }
  });

  $$('[data-ix]').forEach((wrap) => {
    const float = $('.ix__float', wrap); if (!float) return;
    const img = $('img', float);
    let x = 0, y = 0, cx = 0, cy = 0, on = false, raf;
    const loop = () => { cx += (x - cx) * .16; cy += (y - cy) * .16; float.style.left = cx + 'px'; float.style.top = cy + 'px'; if (on) raf = requestAnimationFrame(loop); };
    $$('.ix__row', wrap).forEach((row) => {
      row.addEventListener('mouseenter', (e) => {
        const src = row.dataset.img; if (!src) return;
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
        x = cx = e.clientX; y = cy = e.clientY;
        float.classList.add('is-on'); on = true; cancelAnimationFrame(raf); loop();
      });
      row.addEventListener('mousemove', (e) => { x = e.clientX; y = e.clientY; });
      row.addEventListener('mouseleave', () => { float.classList.remove('is-on'); on = false; });
    });
  });

  $$('[data-lb]').forEach((wrap) => {
    const track = $('.lb__track', wrap);
    $$('[data-lb-dir]', wrap).forEach((b) => b.addEventListener('click', () => {
      const dir = parseInt(b.dataset.lbDir, 10);
      track.scrollBy({ left: dir * track.clientWidth * .7, behavior: 'smooth' });
    }));
  });

  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -10% 0px' });
    $$('.ix__row, .dc__title, .lb__item, .hc__word').forEach((el, i) => { el.classList.add('split-in'); el.style.transitionDelay = `${(i % 5) * 70}ms`; io.observe(el); });
  }
})();